<template>
  <b-container fluid>
    <b-row class="my-2">
      <b-col class="col-left">
        <b-button
          v-if="content === 'table'"
          variant="warning"
          @click="contentHandler('form')"
        >
          สร้างเส้นทาง
        </b-button>
        <b-button
          v-if="content === 'form'"
          @click="backHandler"
        >
          ย้อนกลับ
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <direction-table
          v-show="content === 'table'"
          :items.sync="items"
          :update-data-handler="updateDataHandler"
          :content-handler="contentHandler"
          :get-data-handler="getDataHandler"
          :delete-data-handler="deleteDataHandler"
        />
        <direction-form
          v-show="content === 'form'"
          :item.sync="itemSelected"
          :create-data-handler="createDataHandler"
          :update-data-handler="updateDataHandler"
          :back-handler="backHandler"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import {mapActions} from "vuex";
  import DirectionForm from "./DirectionForm";
  import DirectionTable from "./DirectionTable";

  export default {
    name: "DirectionView",
    components: {DirectionTable, DirectionForm},
    data() {
      return {
        items: [],
        itemSelected: {
          id: null,
          direction: null,
        },
        content: 'table' // table, form
      }
    },
    async mounted() {
      this.items = await this.fetchData() // fetch data axios
    },
    methods: {
      ...mapActions({
        'fetchData': 'Settings/getDirections',
        'updateData': 'Settings/updateDirection',
        'deleteData': 'Settings/deleteDirection',
        'createData': 'Settings/createDirection',
        'getData': 'Settings/getDirection'

      }),
      async updateDataHandler(id, rowUpdate=null, password) {
        // add loading
        this.$store.state.isLoading = true
        // find selected item
        if (!rowUpdate) {
          rowUpdate = this.items.find(item => item.id === id)
        }
        // condition item not found
        if (!rowUpdate) {
          // show alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', 'id ไม่ถูกต้อง', 'error')
          // remove loading
          this.$store.state.isLoading = false
          return
        }
        try {
          // update data axios
          await this.updateData({id: id, payload: rowUpdate, password })
        } catch (error) {
          // alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', `${error.message}`, 'error')
          // remove loading
          this.$store.state.isLoading = false
          return
        }
        // fetch new data axios
        this.items = await this.fetchData()
        // alert update success
        await this.$swal.fire('สำเร็จ', 'แก้ไขข้อมูลสำเร็จ', 'success')
        // remove loading
        this.$store.state.isLoading = false
      },
      async createDataHandler(payload, password) {
        // add loading
        this.$store.state.isLoading = true
        try {
          // create data axios
          await this.createData({payload, password})
        } catch (error) {
          // alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', `${error.message}`, 'error')
          // remove loading
          this.$store.state.isLoading = false
          return
        }
        // fetch new data axios
        this.items = await this.fetchData()
        // alert success
        await this.$swal.fire('สำเร็จ', 'แก้ไขข้อมูลสำเร็จ', 'success')
        // remove loading
        this.$store.state.isLoading = false
      },
      async deleteDataHandler(id, password) {
        // add loading
        this.$store.state.isLoading = true
        // find item
        const rowUpdate = this.items.find(item => item.id === id)
        // condition item not found
        if (!rowUpdate) {
          // alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', 'id ไม่ถูกต้อง', 'error')
          // remove loading
          this.$store.state.isLoading = false
          return
        }
        try {
          // delete data axios
          await this.deleteData({id, password})
        } catch (error) {
          await this.$swal.fire('เกิดข้อผิดพลาด', `${error.message}`, 'error')
          this.$store.state.isLoading = false
          return
        }
        // fetch new data axios
        this.items = await this.fetchData()
        // alert success
        await this.$swal.fire('สำเร็จ', 'แก้ไขข้อมูลสำเร็จ', 'success')
        // remove loading
        this.$store.state.isLoading = false
      },
      contentHandler(content) {
        // change content page between 'form' and 'table'
        this.content = content
      },
      async getDataHandler(id) {
        let res
        try {
          // fetch data by id axios
          res = await this.getData(id)
        } catch (error) {
          // alert error
          await this.$swal.fire('เกิดข้อผิดพลาด', `${error.message}`, 'error')
        }
        // assign value to item selected
        this.itemSelected = {
          id: res.id,
          direction: res.direction,
        }
        // remove loading
        this.$store.state.isLoading = false
      },
      backHandler() {
        // clear item selected
        this.itemSelected = {
          id: null,
          direction: null,
        }
        // change content to table
        this.content = 'table'
      }
    },
  }
</script>

<style scoped>

</style>